import checkmark from "./checkmark.svg";
import chevron from "./chevron.svg";
import passwordCrossedIcon from "./password-crossed.svg";
import passwordIcon from "./password.svg";
import smallCrossIcon from "./small-cross.svg";

export {
  checkmark,
  chevron,
  passwordCrossedIcon,
  passwordIcon,
  smallCrossIcon
};
